export const inviteEmailText = (code, origin) => `Subject: You're invited to beta test Root & Rose

Hi there,

I'm inviting a small group of people to try Root & Rose — an app I'm shaping to help people start (or stop) habits with encouragement only, never penalties. You'd be one of the first to use it, and your honest feedback will directly shape what it becomes.

Getting started takes about 3 minutes:
1. Open your invite link: ${origin}/beta?code=${code}
2. Create an account (your invite code ${code} is filled in for you)
3. Add one or two habits you actually care about, then check in once a day

What I'd love from you during the beta:
- Use it most days for 2–3 weeks — even a 30-second check-in counts
- Tap the "Feedback" button in the app whenever something feels confusing, delightful, or broken
- Tell me what you'd want before you'd keep using it

A few honest notes:
- This is a beta on a test server. Please use made-up or minimal details — don't enter anything you'd consider sensitive health information yet
- The app is not a crisis service. If you're in crisis, call or text 988 (US) or your local emergency number
- You can export or delete everything you've entered at any time from the Security page

Thank you for being here at the very start. It genuinely matters.

Warmly,
`;
